module.exports = __webpack_public_path__ + "static/img/gravitational_waves.5802532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gravitational_waves.jpg
// module id = Zdoy
// module chunks = 0